import React from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { CFA_INFO } from '../data/constants';
export function MentionsLegales() {
  return <div className="flex flex-col w-full bg-muted min-h-screen" data-id="element-1671" data-mp="zub007fgoq47">
      <PageHeader title="Mentions Légales" subtitle="Dernière mise à jour : 21/06/2026" data-id="element-1672" data-mp="14s2xdgyvl4fs" />
      <div className="container max-w-4xl mx-auto py-16 md:py-24" data-id="element-1673" data-mp="19kma6bpqnvjj">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl max-w-none" data-id="element-1674" data-mp="1ejgwhnmx028e">
          <p className="text-xl md:text-2xl font-medium text-primary-dark leading-snug mb-8" data-id="element-1675" data-mp="1ik93ea8bdv1i">
            Conformément aux dispositions légales en vigueur, les présentes
            mentions légales ont pour objet d'identifier l'éditeur du site
            internet de Zillenium Alternance et de préciser les conditions
            d'utilisation du site.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1676" data-mp="3pd36uo5andaz">
            1. Éditeur du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1677" data-mp="1bhhwjq4gdloy">
            Le présent site internet, accessible à l'adresse{' '}
            <a href="https://www.zilleniumalternance.fr" className="text-brand-orange hover:underline font-medium" data-id="element-1678" data-mp="11q3qezhzxnmu">
              www.zilleniumalternance.fr
            </a>
            , est édité par :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1679" data-mp="1ue9b5m91vcmo">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1680" data-mp="1pgr98ftg9xo6">
              <strong className="font-semibold text-slate-900" data-id="element-1681" data-mp="1ldupgls6bvin">
                {CFA_INFO.legalName}
              </strong>
              <br data-id="element-1682" data-mp="1gdykaj7qpy1i" />
              Exerçant sous l'activité Zillenium Alternance
              <br data-id="element-1683" data-mp="9zh4ppspvw6u" />
              Société par actions simplifiée
              <br data-id="element-1684" data-mp="9wv09z14hwsu" />
              SIRET : {CFA_INFO.siret}
              <br data-id="element-1685" data-mp="4ytirijci5jh" />
              Code NAF : 8559A
              <br data-id="element-1686" data-mp="6h0hfqe6lwvh" />
              UAI : {CFA_INFO.uai}
              <br data-id="element-1687" data-mp="6ibj9ko2gujy" />
              Numéro de déclaration d'activité : {CFA_INFO.nda} auprès du Préfet
              de la Région Bourgogne-Franche-Comté
              <br data-id="element-1688" data-mp="3tlzutmjvomh9" />
              Siège social : {CFA_INFO.address}
              <br data-id="element-1689" data-mp="3tlg87sja99ww" />
              Téléphone : {CFA_INFO.phone}
              <br data-id="element-1690" data-mp="1gvyzutpqs2m" />
              E-mail :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-1691" data-mp="1jrw5gxqlcq0">
                {CFA_INFO.email}
              </a>
            </p>
          </div>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1692" data-mp="39yib8tx4d3cw">
            Zillenium Alternance est un Centre de Formation d'Apprentis et
            organisme de formation. L'enregistrement sous le numéro de
            déclaration d'activité ne vaut pas agrément de l'État.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1693" data-mp="35wexfymz9mog">
            2. Directeur de la publication
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1694" data-mp="2hbsb9dqilkrk">
            Le directeur de la publication est :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1695" data-mp="2vclbmf3hza2l">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1696" data-mp="2r8dmwhx1hu4d">
              <strong className="font-semibold text-slate-900" data-id="element-1697" data-mp="358xzuxg9wvpy">
                {CFA_INFO.president}
              </strong>
              <br data-id="element-1698" data-mp="3093d963j6sap" />
              Président de ZILLENIUM SAS
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1699" data-mp="3ezalksztquxo">
            3. Hébergement du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1700" data-mp="3nz60n8wi3a2z">
            Le site{' '}
            <a href="https://www.zilleniumalternance.fr" className="text-brand-orange hover:underline font-medium" data-id="element-1701" data-mp="3j14jitimxku5">
              www.zilleniumalternance.fr
            </a>{' '}
            est hébergé par :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1702" data-mp="1m8f9coc42h2r">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1703" data-mp="1r21pwrleb53u">
              <strong className="font-semibold text-slate-900" data-id="element-1704" data-mp="1v1sc0hzz8x21">
                IONOS SARL
              </strong>
              <br data-id="element-1705" data-mp="ydw2ty6vd40u" />
              7 place de la Gare
              <br data-id="element-1706" data-mp="13bns0kg4qc1c" />
              57200 Sarreguemines
              <br data-id="element-1707" data-mp="13c7d2a12tgjl" />
              France
              <br data-id="element-1708" data-mp="17d94i4or4ob0" />
              Site internet :{' '}
              <a href="https://www.ionos.fr" target="_blank" rel="noopener noreferrer" className="text-brand-orange hover:underline font-medium" data-id="element-1709" data-mp="17bpngbv9u986">
                www.ionos.fr
              </a>
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1710" data-mp="2npxyb96oiu3z">
            4. Activité du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1711" data-mp="2sxe99uz1pei9">
            Le site internet de Zillenium Alternance a pour objet de présenter
            l'activité du CFA, ses formations en alternance, ses modalités
            d'admission, ses dispositifs d'accompagnement, ses informations à
            destination des candidats, apprenants, familles, entreprises,
            partenaires et financeurs.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1712" data-mp="2a7y4gvgbuzw1">
            Les informations publiées sur le site sont fournies à titre
            informatif. Zillenium Alternance s'efforce de garantir l'exactitude,
            la mise à jour et la clarté des informations diffusées. Toutefois,
            des erreurs, omissions ou modifications peuvent intervenir.
            L'utilisateur est invité à contacter Zillenium Alternance pour toute
            demande de précision.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1713" data-mp="1sug6uqptpuem">
            5. Propriété intellectuelle
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1714" data-mp="1jxp826jw01gc">
            L'ensemble des éléments présents sur le site, notamment les textes,
            images, visuels, logos, graphismes, documents, contenus
            pédagogiques, vidéos, icônes, éléments de mise en page et structure
            générale du site, sont protégés par le droit de la propriété
            intellectuelle.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1715" data-mp="22ooscugfsn3a">
            Sauf autorisation préalable et écrite de Zillenium Alternance, toute
            reproduction, représentation, modification, adaptation, diffusion,
            exploitation commerciale ou non commerciale, totale ou partielle, du
            contenu du site est interdite.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1716" data-mp="nnonjjbx6njz">
            Toute utilisation non autorisée du site ou de l'un de ses éléments
            pourra engager la responsabilité de son auteur.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1717" data-mp="xl34dk1r9ect">
            6. Responsabilité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1718" data-mp="4z1hoylx5u5c">
            Zillenium Alternance met tout en œuvre pour assurer l'accessibilité
            et le bon fonctionnement du site. Toutefois, l'accès au site peut
            être interrompu temporairement pour des raisons de maintenance, de
            mise à jour, de sécurité, de problème technique ou de force majeure.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1719" data-mp="3ibtpzpcfz0hf">
            Zillenium Alternance ne saurait être tenue responsable des dommages
            directs ou indirects pouvant résulter de l'accès au site, de son
            utilisation, d'une interruption, d'un dysfonctionnement, d'une
            erreur ou d'une impossibilité d'accès.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1720" data-mp="31seruvrbeaq5">
            L'utilisateur reconnaît utiliser le site sous sa seule
            responsabilité.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1721" data-mp="3auwcj5rbmvb1">
            7. Liens hypertextes
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1722" data-mp="3kk7k2nyk7rwt">
            Le site peut contenir des liens vers des sites tiers, partenaires,
            institutions, organismes certificateurs, financeurs, plateformes
            administratives ou ressources externes.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1723" data-mp="2e1jei0bspa5">
            Zillenium Alternance ne peut être tenue responsable du contenu, du
            fonctionnement, de la disponibilité ou des pratiques de ces sites
            tiers. L'accès à ces sites relève de la responsabilité de
            l'utilisateur.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1724" data-mp="1dwgjzkpxri1s">
            Toute création de lien hypertexte vers le site de Zillenium
            Alternance doit faire l'objet d'une autorisation préalable, sauf
            accord ou usage expressément autorisé.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1725" data-mp="21mawg16cf4li">
            8. Données personnelles
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1726" data-mp="1rvyfsk1nfvkn">
            Dans le cadre de l'utilisation du site, Zillenium Alternance peut
            être amenée à collecter et traiter des données personnelles,
            notamment via les formulaires de contact, de demande d'information,
            de candidature ou de mise en relation.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1727" data-mp="1tkg1t8mdbmko">
            Les modalités de traitement des données personnelles sont détaillées
            dans la{' '}
            <a href="/confidentialite" className="text-brand-orange hover:underline font-medium" data-id="element-1728" data-mp="23i40g9n3he84">
              Politique de confidentialité
            </a>{' '}
            disponible sur le site.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1729" data-mp="27ixkut1bwaw9">
            Pour toute question relative aux données personnelles, l'utilisateur
            peut contacter Zillenium Alternance à l'adresse suivante :{' '}
            <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-1730" data-mp="2h8pkw2s75w84">
              {CFA_INFO.rgpdEmail}
            </a>
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1731" data-mp="2r87ze3pc8pss">
            9. Cookies et traceurs
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1732" data-mp="3et8oq5cmtwqk">
            Le site peut utiliser des cookies ou traceurs nécessaires à son
            fonctionnement, à la mesure d'audience, à l'amélioration de
            l'expérience utilisateur ou, le cas échéant, à des finalités de
            communication ou de suivi statistique.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1733" data-mp="2vvfya2j73fa2">
            Lorsque des cookies nécessitent le consentement de l'utilisateur, un
            bandeau d'information et de gestion des préférences est affiché lors
            de la navigation sur le site.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1734" data-mp="285lhj9vr96kj">
            L'utilisateur peut à tout moment modifier ses préférences relatives
            aux cookies selon les modalités prévues sur le site.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1735" data-mp="iozstiqzzs6f">
            10. Contact
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1736" data-mp="9vd0k2m0171z">
            Pour toute question relative au site, à son contenu, aux formations
            ou aux présentes mentions légales, l'utilisateur peut contacter
            Zillenium Alternance :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1737" data-mp="xlh1g27syspa">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1738" data-mp="xjmg4msmcyko">
              <strong className="font-semibold text-slate-900" data-id="element-1739" data-mp="skt1gr1lj1ix">
                Zillenium Alternance
              </strong>
              <br data-id="element-1740" data-mp="npdos2fbrbo3" />
              {CFA_INFO.address}
              <br data-id="element-1741" data-mp="3dcv43xuqnrwl" />
              Téléphone : {CFA_INFO.phone}
              <br data-id="element-1742" data-mp="38di8anlw3ahv" />
              E-mail :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-1743" data-mp="38cqp6c9hb58h">
                {CFA_INFO.email}
              </a>
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1744" data-mp="336br80hovhek">
            11. Droit applicable
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1745" data-mp="3czsml8xh54kc">
            Les présentes mentions légales sont soumises au droit français.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1746" data-mp="3lycwbkl243wf">
            En cas de litige relatif à l'utilisation du site, les parties
            s'efforceront de rechercher une solution amiable. À défaut, le
            litige sera soumis aux juridictions françaises compétentes.
          </p>
        </div>
      </div>
    </div>;
}
export function Confidentialite() {
  return <div className="flex flex-col w-full bg-muted min-h-screen" data-id="element-1747" data-mp="21ij4oqtzukl5">
      <PageHeader title="Politique de Confidentialité" subtitle="Dernière mise à jour : 21/06/2026" data-id="element-1748" data-mp="3s0el7yo01yrj" />
      <div className="container max-w-4xl mx-auto py-16 md:py-24" data-id="element-1749" data-mp="3n1uznzdbiozp">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl max-w-none" data-id="element-1750" data-mp="3n3o4ra8a915l">
          <p className="text-xl md:text-2xl font-medium text-primary-dark leading-snug mb-6" data-id="element-1751" data-mp="4uxcd83gsyyw">
            La présente Politique de confidentialité a pour objectif d'informer
            les utilisateurs du site internet de Zillenium Alternance sur la
            manière dont leurs données personnelles peuvent être collectées,
            utilisées, conservées et protégées.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-8" data-id="element-1752" data-mp="3i3te97sf6dl2">
            Zillenium Alternance accorde une importance particulière à la
            protection des données personnelles des candidats, apprenants,
            familles, entreprises, partenaires, financeurs et utilisateurs de
            son site internet.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1753" data-mp="1052cdv4oxmtm">
            1. Responsable du traitement
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1754" data-mp="r447lamfhb9z">
            Le responsable du traitement des données personnelles est :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1755" data-mp="w3qhba31s9e1">
            <p className="text-sm text-slate-600 leading-relaxed mb-4" data-id="element-1756" data-mp="1ju4d9bor6sdw">
              <strong className="font-semibold text-slate-900" data-id="element-1757" data-mp="1nuwlq2pswt94">
                {CFA_INFO.legalName}
              </strong>
              <br data-id="element-1758" data-mp="19ttyvnqzfex5" />
              Exerçant sous l'activité Zillenium Alternance
              <br data-id="element-1759" data-mp="1esx5vdqivv7r" />
              Centre de Formation d'Apprentis et organisme de formation
              <br data-id="element-1760" data-mp="3ukb7r75mwqe0" />
              SIRET : {CFA_INFO.siret}
              <br data-id="element-1761" data-mp="3umxhndfzzhze" />
              UAI : {CFA_INFO.uai}
              <br data-id="element-1762" data-mp="3fkxcpjtiof9" />
              NDA : {CFA_INFO.nda}
              <br data-id="element-1763" data-mp="3c6w5kmw4l9e" />
              Siège social : {CFA_INFO.address}
              <br data-id="element-1764" data-mp="3fhb8ak11a9l0" />
              Représentée par {CFA_INFO.president}, Président
            </p>
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1765" data-mp="3bgrbxioab9zx">
              Contact général :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-1766" data-mp="36ny2ihhvfdhi">
                {CFA_INFO.email}
              </a>
              <br data-id="element-1767" data-mp="2wsmmlvuq8086" />
              Contact RGPD :{' '}
              <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-1768" data-mp="2rryzhl9mc3j8">
                {CFA_INFO.rgpdEmail}
              </a>
            </p>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1769" data-mp="2itn1gy6fa3gr">
            2. Données personnelles collectées
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1770" data-mp="h0yx2li1l9ze">
            Dans le cadre de son activité, Zillenium Alternance peut être amenée
            à collecter les données personnelles suivantes :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1771" data-mp="y9jd7upyq196">
            <li data-id="element-1772" data-mp="138mdl1uzzjat">
              Données d'identité : nom, prénom, date de naissance, photographie,
              civilité ;
            </li>
            <li data-id="element-1773" data-mp="5lvr2b91n2kf">
              Données de contact : adresse e-mail, numéro de téléphone, adresse
              postale ;
            </li>
            <li data-id="element-1774" data-mp="am1grlvr6ezv">
              Données liées au parcours : niveau scolaire, diplômes, expériences
              professionnelles, CV, lettre de motivation, projet professionnel,
              formation souhaitée ;
            </li>
            <li data-id="element-1775" data-mp="1qyq7ghidw4om">
              Données administratives nécessaires à l'admission ou au suivi :
              pièces justificatives, documents d'inscription, informations liées
              au contrat d'apprentissage, informations transmises par
              l'entreprise ou le financeur ;
            </li>
            <li data-id="element-1776" data-mp="2c2r8bpn0rifp">
              Données relatives à l'entreprise : nom de l'entreprise,
              coordonnées professionnelles, identité du représentant légal,
              maître d'apprentissage, fonction, coordonnées de contact ;
            </li>
            <li data-id="element-1777" data-mp="2lyc61bl21wjn">
              Données de suivi pédagogique : assiduité, évaluations, entretiens,
              bilans, progression, documents de suivi ;
            </li>
            <li data-id="element-1778" data-mp="2urxmczcvblv6">
              Données de navigation : adresse IP, données techniques, cookies,
              préférences de navigation, statistiques de consultation du site ;
            </li>
            <li data-id="element-1779" data-mp="34ry5olaqm1zd">
              Données transmises volontairement par l'utilisateur dans le cadre
              d'un formulaire, d'un e-mail, d'un appel ou d'un échange avec
              Zillenium Alternance.
            </li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1780" data-mp="1af8e4a7ud4v5">
            Zillenium Alternance veille à ne collecter que les données
            nécessaires aux finalités poursuivies.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1781" data-mp="3caflf997id0s">
            3. Finalités des traitements
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1782" data-mp="3h75zjr1gayjk">
            Les données personnelles collectées peuvent être utilisées pour les
            finalités suivantes :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1783" data-mp="37900riaxy8ix">
            <li data-id="element-1784" data-mp="2tdwij1ozxlco">
              Répondre aux demandes d'information envoyées via le site, par
              e-mail ou par téléphone ;
            </li>
            <li data-id="element-1785" data-mp="rl8eiq4j2tvu">Gérer les candidatures et demandes d'admission ;</li>
            <li data-id="element-1786" data-mp="wj1g15uvyzps">
              Analyser l'adéquation entre le profil du candidat, son projet
              professionnel et la formation visée ;
            </li>
            <li data-id="element-1787" data-mp="20250pq6l0rhg">
              Organiser les entretiens, positionnements, réunions d'information
              et rendez-vous ;
            </li>
            <li data-id="element-1788" data-mp="1r3b7m9sgmj8n">
              Accompagner les candidats dans leur recherche d'alternance ;
            </li>
            <li data-id="element-1789" data-mp="1v3ldznk5zbo1">
              Établir, suivre et gérer les dossiers administratifs liés à la
              formation ;
            </li>
            <li data-id="element-1790" data-mp="2iuqrhw2mtrv6">
              Préparer et suivre les contrats d'apprentissage, conventions de
              formation et documents nécessaires ;
            </li>
            <li data-id="element-1791" data-mp="29u2b4uprnff4">
              Assurer le suivi pédagogique, l'assiduité, les évaluations et
              l'accompagnement des apprenants ;
            </li>
            <li data-id="element-1792" data-mp="2eu6x309g12cq">
              Échanger avec les entreprises, maîtres d'apprentissage, OPCO,
              certificateurs, partenaires et autorités compétentes ;
            </li>
            <li data-id="element-1793" data-mp="13ei9q7sa21be">
              Gérer les réclamations, demandes RGPD et démarches qualité ;
            </li>
            <li data-id="element-1794" data-mp="uy9g49ccodcb">
              Améliorer le site internet, les services, la communication et
              l'expérience utilisateur ;
            </li>
            <li data-id="element-1795" data-mp="14umal9fpyv84">
              Respecter les obligations légales, réglementaires,
              administratives, comptables et contractuelles applicables à
              l'activité de CFA et d'organisme de formation.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1796" data-mp="c3m66xdh7pfx">
            4. Bases légales des traitements
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1797" data-mp="lxl23emyiczf">
            Selon les situations, les traitements de données réalisés par
            Zillenium Alternance reposent sur l'une des bases légales suivantes
            :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1798" data-mp="3kma40uviy5m6">
            <li data-id="element-1799" data-mp="1oj5drik5hvdq">
              L'exécution de mesures précontractuelles, notamment pour répondre
              à une demande d'information, étudier une candidature ou préparer
              une admission ;
            </li>
            <li data-id="element-1800" data-mp="1y8oyyuvc61br">
              L'exécution d'un contrat, notamment dans le cadre d'une formation,
              d'un contrat d'apprentissage ou d'une convention de formation ;
            </li>
            <li data-id="element-1801" data-mp="15kt2nr9oibfi">
              Le respect d'obligations légales et réglementaires applicables aux
              CFA, organismes de formation, employeurs, financeurs et
              certificateurs ;
            </li>
            <li data-id="element-1802" data-mp="1eiuzdumdqhwz">
              L'intérêt légitime de Zillenium Alternance, notamment pour assurer
              le suivi des demandes, améliorer ses services, gérer sa
              communication, sécuriser son site et assurer le bon fonctionnement
              de son activité ;
            </li>
            <li data-id="element-1803" data-mp="2uwl6794vvkab">
              Le consentement de la personne concernée, notamment lorsque
              celui-ci est requis pour certains cookies, communications ou
              traitements spécifiques.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1804" data-mp="2vcjlnmdzwwb0">
            5. Destinataires des données
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1805" data-mp="2mbv9yyc2r81a">
            Les données personnelles collectées sont destinées aux services
            internes habilités de Zillenium Alternance.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1806" data-mp="2cd5qj14j5fix">
            Elles peuvent également être transmises, uniquement lorsque cela est
            nécessaire, aux destinataires suivants :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1807" data-mp="alau1squhhla">
            <li data-id="element-1808" data-mp="6lsab0arfck1">
              Entreprises d'accueil ou entreprises partenaires dans le cadre de
              la recherche d'alternance ;
            </li>
            <li data-id="element-1809" data-mp="dm455onlzrur">Maîtres d'apprentissage et tuteurs ;</li>
            <li data-id="element-1810" data-mp="ilp9yfpgmufe">OPCO et organismes financeurs ;</li>
            <li data-id="element-1811" data-mp="4n8zcdoh8jrz">
              Certificateurs, jurys, autorités académiques ou organismes
              habilités ;
            </li>
            <li data-id="element-1812" data-mp="8nsytnwivzha">
              Administrations, autorités de contrôle ou organismes légalement
              compétents ;
            </li>
            <li data-id="element-1813" data-mp="3r0qrd9qzjq1f">
              Prestataires techniques intervenant pour le fonctionnement du
              site, des outils numériques, de l'hébergement, de la maintenance
              ou de la gestion administrative ;
            </li>
            <li data-id="element-1814" data-mp="3m37ead60xjb2">
              Partenaires pédagogiques ou institutionnels lorsque leur
              intervention est nécessaire au parcours de formation.
            </li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1815" data-mp="3d32fgrewbt8i">
            Zillenium Alternance ne vend pas les données personnelles des
            utilisateurs.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1816" data-mp="2tj3lgvieee7f">
            6. Durée de conservation des données
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1817" data-mp="32fm4ng0tunqt">
            Les données personnelles sont conservées pendant une durée limitée,
            déterminée en fonction de la finalité du traitement, de la nature
            des données et des obligations légales applicables. À titre
            indicatif :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1818" data-mp="3m67nqsq3wefi">
            <li data-id="element-1819" data-mp="3h6laijaa2y6p">
              Les données liées aux demandes de contact sont conservées le temps
              nécessaire au traitement de la demande, puis archivées pendant une
              durée raisonnable ;
            </li>
            <li data-id="element-1820" data-mp="3q945yibqi8ix">
              Les données liées aux candidatures non retenues peuvent être
              conservées pendant une durée maximale de 2 ans, sauf opposition de
              la personne concernée ;
            </li>
            <li data-id="element-1821" data-mp="2squ5973k8v4a">
              Les données liées aux apprenants, contrats d'apprentissage,
              conventions, justificatifs de formation, éléments de suivi
              pédagogique, facturation et documents administratifs sont
              conservées pendant la durée nécessaire au suivi du parcours, puis
              selon les obligations légales, réglementaires, comptables,
              contractuelles ou de contrôle applicables ;
            </li>
            <li data-id="element-1822" data-mp="3gjalrd7ngf1h">
              Les données nécessaires à la gestion des réclamations ou demandes
              RGPD sont conservées le temps nécessaire au traitement de la
              demande et à la preuve de sa gestion ;
            </li>
            <li data-id="element-1823" data-mp="1q6d4pkdpjy59">
              Les cookies soumis au consentement sont conservés selon les durées
              prévues par la réglementation applicable et les paramètres définis
              dans l'outil de gestion des cookies.
            </li>
          </ul>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1824" data-mp="1dukcofrnqe4j">
            7. Sécurité des données
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1825" data-mp="14wqipbhd7wkj">
            Zillenium Alternance met en œuvre des mesures techniques,
            organisationnelles et humaines raisonnables afin de protéger les
            données personnelles contre la perte, l'accès non autorisé, la
            divulgation, l'altération, la destruction ou l'utilisation abusive.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1826" data-mp="1nkvlafmadbhr">
            L'accès aux données est limité aux personnes habilitées, dans la
            limite de leurs missions et responsabilités.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1827" data-mp="c56ybo918cgy">
            Les prestataires susceptibles d'intervenir sur les données
            personnelles sont tenus de respecter des obligations de
            confidentialité, de sécurité et de protection des données.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1828" data-mp="22cejkh5ltexu">
            8. Droits des personnes concernées
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1829" data-mp="2v00xojcgk1yy">
            Conformément à la réglementation applicable en matière de protection
            des données personnelles, toute personne concernée dispose des
            droits suivants :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1830" data-mp="2q80p62ibo0qr">
            <li data-id="element-1831" data-mp="3dy3dq8n12okm">Droit d'accès à ses données personnelles ;</li>
            <li data-id="element-1832" data-mp="3dwk1ct4hsxo4">
              Droit de rectification des données inexactes ou incomplètes ;
            </li>
            <li data-id="element-1833" data-mp="179upyx5t58ta">
              Droit à l'effacement des données, dans les limites prévues par la
              réglementation ;
            </li>
            <li data-id="element-1834" data-mp="12a8dipxszwlj">Droit à la limitation du traitement ;</li>
            <li data-id="element-1835" data-mp="1g26e2cdg8k63">
              Droit d'opposition au traitement, lorsque celui-ci repose sur
              l'intérêt légitime ;
            </li>
            <li data-id="element-1836" data-mp="1c1crpnfnndfb">
              Droit à la portabilité des données, lorsque ce droit est
              applicable ;
            </li>
            <li data-id="element-1837" data-mp="od390udqn5se">
              Droit de retirer son consentement à tout moment, lorsque le
              traitement repose sur le consentement ;
            </li>
            <li data-id="element-1838" data-mp="xcq0oogo0x89">
              Droit de définir des directives relatives au sort de ses données
              après son décès.
            </li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1839" data-mp="28qtu9tjccjcs">
            Pour exercer ces droits, la personne concernée peut contacter
            Zillenium Alternance à l'adresse suivante :{' '}
            <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-1840" data-mp="2if3c3iisq158">
              {CFA_INFO.rgpdEmail}
            </a>
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1841" data-mp="29eyfm3f54n5u">
            La demande devra préciser l'identité du demandeur, l'objet de la
            demande et, si nécessaire, les éléments permettant de l'identifier.
            Une pièce justificative d'identité pourra être demandée uniquement
            en cas de doute raisonnable sur l'identité du demandeur.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1842" data-mp="2sbzldqgiqrau">
            9. Réclamation auprès de la CNIL
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1843" data-mp="3ktbyetv1ecf0">
            Si la personne concernée estime, après avoir contacté Zillenium
            Alternance, que ses droits ne sont pas respectés ou que le
            traitement de ses données personnelles n'est pas conforme à la
            réglementation applicable, elle peut adresser une réclamation à la
            Commission Nationale de l'Informatique et des Libertés, la CNIL.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1844" data-mp="18mqn9nupusf">
            10. Formulaires du site
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1845" data-mp="a4vs0tve33h7">
            Les formulaires présents sur le site peuvent permettre à
            l'utilisateur de :
          </p>
          <ul className="list-disc pl-6 mb-6 space-y-2 text-slate-700 text-base leading-relaxed" data-id="element-1846" data-mp="jxjo1mejp3ev">
            <li data-id="element-1847" data-mp="ov314iziba58">Demander des informations sur une formation ;</li>
            <li data-id="element-1848" data-mp="tvqtp93dvz1k">Déposer une candidature ;</li>
            <li data-id="element-1849" data-mp="tsuuzijpp6c2">Demander à être recontacté ;</li>
            <li data-id="element-1850" data-mp="xvrj1os0tune">Contacter le CFA ;</li>
            <li data-id="element-1851" data-mp="xwsrrmlke51y">Transmettre une demande en tant qu'entreprise ;</li>
            <li data-id="element-1852" data-mp="2uy8dfp04welk">Signaler une réclamation ou une difficulté.</li>
          </ul>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1853" data-mp="2pym0lgo7x0da">
            Les champs obligatoires sont signalés comme tels lorsqu'ils sont
            nécessaires au traitement de la demande. À défaut de renseignement
            des informations obligatoires, Zillenium Alternance pourrait ne pas
            être en mesure de répondre à la demande ou de traiter le dossier.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1854" data-mp="38p3ggknyc1h8">
            11. Cookies et traceurs
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1855" data-mp="3in1353q5xq7q">
            Le site peut utiliser des cookies ou traceurs afin de permettre son
            bon fonctionnement, mesurer son audience, améliorer l'expérience
            utilisateur ou proposer certains contenus intégrés.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1856" data-mp="1e49z843wxiz7">
            Certains cookies sont strictement nécessaires au fonctionnement du
            site et ne nécessitent pas le consentement de l'utilisateur.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1857" data-mp="14eh042kyiwbu">
            Les cookies non essentiels, notamment ceux liés à la mesure
            d'audience avancée, au marketing, aux réseaux sociaux ou aux
            contenus tiers, peuvent nécessiter le consentement préalable de
            l'utilisateur.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1858" data-mp="zdj8z0hyyry7">
            Lors de sa première visite, l'utilisateur peut accepter, refuser ou
            personnaliser ses choix via le bandeau de gestion des cookies,
            lorsque celui-ci est requis.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1859" data-mp="2fuxavilkgosd">
            L'utilisateur peut modifier ses préférences à tout moment depuis le
            module de gestion des cookies disponible sur le site.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1860" data-mp="fs5sjzyp2hl5">
            12. Transferts de données hors Union européenne
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1861" data-mp="6rr44rqfomdf">
            Dans la mesure du possible, Zillenium Alternance privilégie des
            outils et prestataires permettant un hébergement et un traitement
            des données au sein de l'Union européenne.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1862" data-mp="3o7fzbldj4az9">
            Toutefois, certains outils numériques, solutions techniques ou
            prestataires peuvent impliquer un transfert de données en dehors de
            l'Union européenne. Dans ce cas, Zillenium Alternance veille à ce
            que ces transferts soient encadrés par des garanties appropriées
            conformément à la réglementation applicable.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1863" data-mp="1ppmdhfhzs1sn">
            13. Confidentialité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1864" data-mp="1yrvkhve1xd1a">
            Zillenium Alternance s'engage à préserver la confidentialité des
            informations transmises dans le cadre des demandes d'information,
            candidatures, admissions, formations, relations entreprises,
            accompagnements et échanges administratifs.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1865" data-mp="1fzkq6pxgqnes">
            Les données personnelles ne sont accessibles qu'aux personnes ayant
            besoin d'en connaître dans le cadre de leurs missions.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1866" data-mp="navuj6f6faaf">
            14. Modification de la politique de confidentialité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1867" data-mp="1vjkuzru92k6o">
            Zillenium Alternance se réserve le droit de modifier la présente
            Politique de confidentialité à tout moment, notamment afin de tenir
            compte des évolutions légales, réglementaires, techniques,
            organisationnelles ou pédagogiques.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1868" data-mp="1cnl2mfxd1emk">
            La version applicable est celle publiée sur le site à la date de
            consultation.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1869" data-mp="1lnhwqx2ir5p0">
            15. Contact
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1870" data-mp="2x2emyaafw0xy">
            Pour toute question relative à la présente Politique de
            confidentialité ou au traitement des données personnelles,
            l'utilisateur peut contacter :
          </p>
          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1871" data-mp="30j125vysy2mn">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1872" data-mp="34nh6vtwoj40a">
              <strong className="font-semibold text-slate-900" data-id="element-1873" data-mp="2qmy1kujlmc1t">
                Zillenium Alternance
              </strong>
              <br data-id="element-1874" data-mp="2vm0w3l1yczvj" />
              {CFA_INFO.address}
              <br data-id="element-1875" data-mp="3jb281i9zut5k" />
              E-mail général :{' '}
              <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-1876" data-mp="3jbbwv2jayu9o">
                {CFA_INFO.email}
              </a>
              <br data-id="element-1877" data-mp="39kqtz2wlj3ky" />
              E-mail RGPD :{' '}
              <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-1878" data-mp="3ejbtt17xrl8v">
                {CFA_INFO.rgpdEmail}
              </a>
              <br data-id="element-1879" data-mp="aw1z26mg4b7p" />
              Téléphone : {CFA_INFO.phone}
            </p>
          </div>
        </div>
      </div>
    </div>;
}
export function CGV() {
  return <div className="flex flex-col w-full bg-muted min-h-screen" data-id="element-1880" data-mp="227oqb0fcwuxt">
      <PageHeader title="Conditions Générales de Vente" subtitle="Version 1.0 — Applicable à compter du 1er septembre 2025" data-id="element-1881" data-mp="225byzwnpl883" />
      <div className="container max-w-4xl mx-auto py-16 md:py-24" data-id="element-1882" data-mp="1t7jjoshzm0kp">
        <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl max-w-none" data-id="element-1883" data-mp="2px0x5tn7oqwy">
          <p className="text-xl md:text-2xl font-medium text-primary-dark leading-snug mb-8" data-id="element-1884" data-mp="2puwutg4ynzys">
            Les présentes Conditions générales de vente (CGV) s'appliquent à
            l'ensemble des prestations de formation dispensées par{' '}
            {CFA_INFO.name}.
          </p>

          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 mb-8" data-id="element-1885" data-mp="2bwyishe44fmg">
            <p className="text-sm text-slate-600 leading-relaxed" data-id="element-1886" data-mp="15hxo0f0tq3hg">
              ZILLENIUM SAS — Centre de Formation d'Apprentis et organisme de
              formation — SIRET : {CFA_INFO.siret} — Code NAF : 8559A — UAI :{' '}
              {CFA_INFO.uai}
              <br data-id="element-1887" data-mp="3h49haxqa7wrf" />
              Siège social : {CFA_INFO.address} — Président et responsable légal
              : {CFA_INFO.president}
              <br data-id="element-1888" data-mp="3l5baoxxipelh" />
              Téléphone : {CFA_INFO.phone} — Email : {CFA_INFO.email} — Contact
              RGPD : {CFA_INFO.rgpdEmail} — Réclamations : {CFA_INFO.email}
            </p>
          </div>

          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1889" data-mp="3uve9jerblmrq">
            ZILLENIUM SAS est un organisme de formation déclaré auprès de la
            DREETS Bourgogne-Franche-Comté et enregistré sous le numéro{' '}
            {CFA_INFO.nda} auprès du Préfet de la Région
            Bourgogne-Franche-Comté. Cet enregistrement ne vaut pas agrément de
            l'État.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1890" data-mp="2ahnfbq3qoyv7">
            1. Désignation et identité de l'organisme
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1891" data-mp="2po06rdp2ek96">
            Les présentes Conditions générales de vente sont établies par{' '}
            <strong className="font-semibold text-slate-900" data-id="element-1892" data-mp="2yopwq0rn9gez">
              ZILLENIUM SAS
            </strong>
            , exploitant l'activité{' '}
            <strong className="font-semibold text-slate-900" data-id="element-1893" data-mp="33nj9ts30r5em">
              Zillenium Alternance
            </strong>
            , centre de formation d'apprentis et organisme de formation dont le
            siège social est situé {CFA_INFO.address}.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1894" data-mp="2fxp03jdzxwyl">
            ZILLENIUM SAS est identifiée sous le numéro SIRET {CFA_INFO.siret},
            code NAF 8559A, et dispose du numéro UAI {CFA_INFO.uai}. L'organisme
            est représenté par son président, {CFA_INFO.president}.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1895" data-mp="1s7um2yhxy2cr">
            Dans les présentes Conditions générales de vente, ZILLENIUM SAS,
            Zillenium Alternance ou le CFA sont désignés indifféremment par «
            Zillenium Alternance », « l'organisme » ou « le CFA ».
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1896" data-mp="1apvutchjgj7g">
            2. Définitions
          </h2>
          <div className="overflow-x-auto mb-8 rounded-xl border border-slate-200 shadow-sm" data-id="element-1897" data-mp="11rtwx5t3q6oe">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-1898" data-mp="wz0uiol3vafh">
              <thead data-id="element-1899" data-mp="s0fryiidsenv">
                <tr className="bg-slate-50" data-id="element-1900" data-mp="s20mw98lxzm9">
                  <th className="p-4 font-semibold text-primary-dark border-b border-slate-200 w-1/4" data-id="element-1901" data-mp="rymjqys4dmdr">
                    Terme
                  </th>
                  <th className="p-4 font-semibold text-primary-dark border-b border-slate-200" data-id="element-1902" data-mp="i1q9oomkos73">
                    Définition
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white" data-id="element-1903" data-mp="3ft4lua6m6pe">
                <tr data-id="element-1904" data-mp="8exg4rkkwgiw">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1905" data-mp="8ffkyclb432f">
                    CFA
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1906" data-mp="3qm3mjsh5e83c">
                    Zillenium Alternance, centre de formation d'apprentis et
                    organisme de formation chargé de concevoir, organiser,
                    suivre et réaliser les actions de formation.
                  </td>
                </tr>
                <tr data-id="element-1907" data-mp="r7hwxan06v6c">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1908" data-mp="des7ew89n84h">
                    Client
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1909" data-mp="icbn80km3syj">
                    L'entreprise, l'employeur, l'organisme financeur, le
                    bénéficiaire contractant ou toute personne morale concluant
                    une convention, un devis ou un contrat avec Zillenium
                    Alternance.
                  </td>
                </tr>
                <tr data-id="element-1910" data-mp="1g7nye11ranec">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1911" data-mp="1g635efv3bcil">
                    Apprenti
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1912" data-mp="1u0dke5habsbg">
                    La personne physique engagée dans un contrat d'apprentissage
                    et bénéficiaire d'une formation alternant périodes en
                    entreprise et périodes au CFA.
                  </td>
                </tr>
                <tr data-id="element-1913" data-mp="1b7i3mc06wks1">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1914" data-mp="1b81j7m2dax2w">
                    Candidat
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1915" data-mp="1673ueqmur4sf">
                    La personne physique sollicitant une information, une
                    admission, un positionnement, un accompagnement ou une mise
                    en relation en vue d'une formation.
                  </td>
                </tr>
                <tr data-id="element-1916" data-mp="r92uwi58qcfa">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1917" data-mp="w5b7bns1zrir">
                    Bénéficiaire
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1918" data-mp="1144obq6ju0no">
                    Toute personne physique bénéficiant d'une action de
                    formation, d'accompagnement, de positionnement ou d'une
                    prestation proposée par Zillenium Alternance.
                  </td>
                </tr>
                <tr data-id="element-1919" data-mp="1f2cenf92y3pv">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1920" data-mp="1jvnrbx0kpepp">
                    OPCO
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1921" data-mp="1otgt8duufmk6">
                    L'opérateur de compétences compétent pour l'entreprise,
                    chargé notamment de l'instruction et de la prise en charge
                    financière d'un contrat d'apprentissage selon les règles
                    applicables.
                  </td>
                </tr>
                <tr data-id="element-1922" data-mp="3ddv1vyzuehq5">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1923" data-mp="3ddcx2dz46v6m">
                    Convention de formation par apprentissage
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1924" data-mp="34dpuvpyk9lci">
                    Le document contractuel conclu entre le CFA et l'entreprise
                    précisant notamment l'intitulé, les objectifs, la durée, le
                    prix, les modalités de réalisation, d'évaluation, de suivi
                    et de règlement de la formation.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1925" data-mp="3na7tmrbtuli9">
            3. Objet et champ d'application
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1926" data-mp="jtikcxkv0xow">
            Les présentes Conditions générales de vente définissent les
            conditions dans lesquelles Zillenium Alternance propose,
            contractualise, réalise, suit et facture ses prestations.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1927" data-mp="txft75a89atg">
            Elles s'appliquent à l'ensemble des actions de formation,
            prestations d'accompagnement, formations en apprentissage, titres
            professionnels, BTS et autres formations proposées par Zillenium
            Alternance, qu'elles soient actuelles ou futures, sauf stipulation
            particulière prévue dans une convention, un devis, un contrat, une
            annexe financière ou un document contractuel accepté par les
            parties.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1928" data-mp="25fqovzm3yve2">
            Les présentes CGV couvrent notamment, sans que cette liste soit
            limitative, les formations suivantes : BTS Négociation et
            Digitalisation de la Relation Client, Titre Professionnel Conseiller
            de Vente, Titre Professionnel Négociateur Technico-Commercial, ainsi
            que toute autre action de formation ouverte ultérieurement par
            Zillenium Alternance.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1929" data-mp="2qz1521jpkki">
            La signature d'une convention, l'acceptation d'un devis, le dépôt
            d'un contrat d'apprentissage, l'inscription ou l'entrée effective en
            formation emporte adhésion aux présentes CGV. Toute condition
            contraire émise par le Client est inopposable à Zillenium
            Alternance, sauf acceptation expresse et écrite de l'organisme.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1930" data-mp="2s8pocpwaqcxy">
            Les actions de formation par apprentissage doivent être encadrées
            par une convention de formation par apprentissage précisant les
            obligations réciproques des parties et les mentions nécessaires
            relatives à l'action de formation, notamment l'intitulé, les
            objectifs, le contenu, les moyens, la durée, les modalités de
            déroulement, de suivi, de sanction, le prix et les modalités de
            règlement.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1931" data-mp="2g4txlzo8oboq">
            4. Information précontractuelle, admission et prérequis
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1932" data-mp="1nir7695df1zf">
            Avant toute entrée en formation, Zillenium Alternance met à
            disposition du candidat, du bénéficiaire ou de l'entreprise les
            informations nécessaires à la compréhension du parcours. Ces
            informations portent notamment sur les objectifs pédagogiques, les
            compétences visées, les prérequis, la durée, le rythme d'alternance,
            les modalités pédagogiques, les modalités d'évaluation, la
            certification visée, les conditions tarifaires, les possibilités de
            financement, les contacts utiles, les conditions d'accessibilité et
            les délais d'accès.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1933" data-mp="iikjuwjm8zqu">
            L'admission repose sur l'analyse du dossier, un entretien, un
            positionnement pédagogique, la vérification des prérequis, l'étude
            du projet professionnel et, pour les formations en alternance, la
            faisabilité du contrat d'apprentissage. L'entrée définitive en
            formation est conditionnée par la disponibilité des places, la
            validation du projet, l'adéquation du profil avec la formation visée
            et, lorsqu'il s'agit d'apprentissage, la signature d'un contrat
            conforme aux règles applicables.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1934" data-mp="1tvd8vzl0va37">
            Le Client atteste avoir vérifié l'adéquation entre les missions
            confiées au bénéficiaire, la formation choisie, les prérequis
            attendus et l'objectif de certification. Zillenium Alternance peut
            refuser, différer ou réorienter une entrée en formation si les
            conditions pédagogiques, administratives, réglementaires,
            contractuelles ou matérielles ne sont pas réunies.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1935" data-mp="1xq6fdfjimdv3">
            5. Documents contractuels et administratifs
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1936" data-mp="27nkw7g9cp4nx">
            Selon la nature de la prestation, les documents contractuels ou
            administratifs peuvent comprendre notamment : le contrat
            d'apprentissage, la convention de formation par apprentissage, le
            devis, le programme de formation, le calendrier d'alternance, le
            règlement intérieur, le livret d'accueil, les annexes pédagogiques,
            les annexes financières, les documents de positionnement, les
            justificatifs de présence et tout document nécessaire à l'exécution
            de la prestation.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1937" data-mp="3lpia0qh2r75s">
            Pour les contrats d'apprentissage, le dépôt auprès de l'OPCO
            nécessite généralement le contrat signé ainsi que les pièces
            annexes, dont la convention de formation avec programme et
            calendrier. Certains OPCO rappellent que le dépôt doit intervenir
            dans un délai rapproché après le début d'exécution du contrat.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1938" data-mp="w68ato7papwd">
            Le règlement intérieur de Zillenium Alternance est communiqué aux
            apprenants avant ou lors de leur entrée en formation. Le
            bénéficiaire s'engage à en respecter les dispositions, notamment en
            matière d'assiduité, de comportement, de sécurité, d'usage des
            locaux, d'évaluation et de discipline.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1939" data-mp="11qnz0xyv15ob">
            6. Prix, financement, OPCO et conditions de prise en charge
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1940" data-mp="n3mbwf82rkrs">
            Les tarifs applicables sont ceux communiqués dans le catalogue, le
            devis, la convention, la proposition commerciale ou tout document
            contractuel accepté par les parties. Pour l'apprenti sous contrat
            d'apprentissage, le coût pédagogique est en principe pris en charge
            selon les règles de financement applicables au contrat
            d'apprentissage. Le reste à charge de l'apprenti est indiqué à{' '}
            <strong className="font-semibold text-slate-900" data-id="element-1941" data-mp="3q6zc3s134613">0 €</strong>, sous
            réserve de la validité du contrat et des règles de prise en charge
            applicables.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1942" data-mp="3ypy0rwmfoqi">
            Les niveaux de prise en charge, les échéanciers de versement, les
            éventuelles majorations ou minorations et les règles de
            proratisation relèvent de l'OPCO compétent et de la réglementation
            en vigueur. Depuis le 1er juillet 2025, le ministère du Travail
            indique que le versement des niveaux de prise en charge est
            proratisé selon le nombre de jours de formation, avec un calendrier
            indicatif de versements de 40 %, puis 30 %, puis 20 %, puis un solde
            de 10 % à la fin du contrat.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1943" data-mp="2ondvyjtmnttk">
            Lorsque la prise en charge OPCO est partielle, refusée, suspendue ou
            remise en cause pour un motif imputable au Client, le solde non
            financé peut être facturé à l'entreprise, sauf disposition contraire
            prévue par la convention ou par les textes applicables. L'entreprise
            demeure responsable de la transmission complète, exacte et sincère
            des informations nécessaires à l'instruction du dossier, notamment
            l'IDCC, les éléments employeur, les dates contractuelles, les pièces
            justificatives et les éléments demandés par l'OPCO.
          </p>

          <div className="overflow-x-auto mb-8 rounded-xl border border-slate-200 shadow-sm" data-id="element-1944" data-mp="1rwqldt1j0s5c">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-1945" data-mp="1mxntlaak4ifb">
              <thead data-id="element-1946" data-mp="1mvks9u3yf2va">
                <tr className="bg-slate-50" data-id="element-1947" data-mp="3to3occjxopyr">
                  <th className="p-4 font-semibold text-primary-dark border-b border-slate-200 w-1/3" data-id="element-1948" data-mp="3towrl3jooxc5">
                    Situation
                  </th>
                  <th className="p-4 font-semibold text-primary-dark border-b border-slate-200" data-id="element-1949" data-mp="2479mcsf5648x">
                    Principe appliqué
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white" data-id="element-1950" data-mp="1uhg9lo39jj33">
                <tr data-id="element-1951" data-mp="1uf3wbo8g9wwd">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1952" data-mp="1zg9onky77i5d">
                    Contrat d'apprentissage pris en charge par l'OPCO
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1953" data-mp="1lf71f4vgw1sv">
                    Facturation au financeur selon l'accord de prise en charge
                    et les règles de règlement applicables.
                  </td>
                </tr>
                <tr data-id="element-1954" data-mp="1ggm2r9vv5q6j">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1955" data-mp="1ghxebvvjw287">
                    Prise en charge partielle
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1956" data-mp="3avgap2duherx">
                    Facturation du reste à charge à l'entreprise, après
                    information et selon les stipulations contractuelles.
                  </td>
                </tr>
                <tr data-id="element-1957" data-mp="34dv9c6btz0f5">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1958" data-mp="2zg3f35npr27s">
                    Refus ou absence de prise en charge
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1959" data-mp="2vft7xpo6q5rc">
                    Facturation possible à l'entreprise si le parcours est
                    maintenu ou si des prestations ont déjà été réalisées.
                  </td>
                </tr>
                <tr data-id="element-1960" data-mp="3ie5yn4xhs6y7">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1961" data-mp="3idmq2etqeuwu">
                    Rupture anticipée du contrat
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1962" data-mp="epuhj9pjco00">
                    Régularisation selon le Code du travail, le contrat
                    d'apprentissage, les règles OPCO et les prestations
                    effectivement réalisées.
                  </td>
                </tr>
                <tr data-id="element-1963" data-mp="1xkp7bafoy4jk">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1964" data-mp="1xk77y4xqfa7f">
                    Abandon ou absence prolongée
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1965" data-mp="21ookbj1ril86">
                    Analyse administrative et financière au cas par cas, avec
                    facturation possible des prestations réalisées ou non prises
                    en charge.
                  </td>
                </tr>
                <tr data-id="element-1966" data-mp="2lajkjt3x9v4c">
                  <td className="p-4 font-medium text-slate-900 align-top" data-id="element-1967" data-mp="2la1i2eqo2knz">
                    Frais annexes éventuels
                  </td>
                  <td className="p-4 text-slate-700 align-top leading-relaxed" data-id="element-1968" data-mp="2pbmxa6qobb1c">
                    Traitement selon les règles du financeur, les justificatifs
                    requis et les accords contractuels.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1969" data-mp="2a99upsx8oyyg">
            7. TVA et régime fiscal
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1970" data-mp="2j72cd3qfoip0">
            Les prestations de formation dispensées par Zillenium Alternance
            bénéficient de l'exonération de TVA prévue à l'article 261-4-4° du
            Code général des impôts. Les tarifs mentionnés dans les conventions,
            contrats, devis et factures sont exprimés nets de taxe.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1971" data-mp="20akb9vpp36g3">
            La mention « TVA non applicable — article 261-4-4° du CGI » est
            intégrée aux documents contractuels et financiers de l'organisme.
            Toute évolution réglementaire, fiscale, administrative ou comptable
            pourra entraîner une adaptation des modalités de facturation
            applicables aux prestations concernées, sans remettre en cause les
            prestations déjà réalisées.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1972" data-mp="yf7o0h8xccwe">
            8. Facturation, règlement et retard de paiement
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1973" data-mp="olz18oi8b8w0">
            Les factures sont émises conformément aux modalités prévues par la
            convention, l'accord de prise en charge de l'OPCO, le devis ou tout
            document contractuel applicable. Le règlement intervient selon
            l'échéancier du financeur ou, en cas de facturation à l'entreprise,
            selon les délais indiqués sur la facture, la convention ou le devis.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1974" data-mp="3n4e4tdpuidpi">
            En cas de retard de paiement imputable au Client, les sommes dues
            deviennent exigibles. Zillenium Alternance pourra appliquer les
            pénalités de retard et indemnités de recouvrement prévues par les
            textes applicables aux relations professionnelles, ainsi que
            suspendre toute prestation non encore réalisée après information
            écrite du Client, sans préjudice de toute action de recouvrement.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1975" data-mp="299udqvwclvjj">
            Aucun escompte n'est accordé en cas de paiement anticipé, sauf
            mention expresse contraire. Les frais bancaires, frais de rejet,
            frais de recouvrement ou frais contentieux consécutifs à un défaut
            de paiement peuvent être refacturés au Client lorsqu'ils sont
            justifiés et légalement exigibles.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1976" data-mp="1qc1ga94hudtj">
            9. Obligations de Zillenium Alternance
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1977" data-mp="1bojhfrdm4df1">
            Zillenium Alternance s'engage à organiser la formation conformément
            au programme communiqué, à mobiliser les moyens pédagogiques
            annoncés, à assurer le suivi de l'assiduité, à informer les parties
            en cas de difficulté significative et à accompagner le bénéficiaire
            dans l'atteinte progressive des compétences visées.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1978" data-mp="1poc5tg1o2hju">
            Le CFA remet ou met à disposition les documents utiles à la
            réalisation de la formation, assure les évaluations pédagogiques
            prévues, conserve les éléments de suivi nécessaires et transmet les
            justificatifs requis, notamment certificats de réalisation,
            attestations d'assiduité ou documents demandés par les financeurs
            dans le cadre du contrôle de service fait.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1979" data-mp="2gg14fwvut0ur">
            Zillenium Alternance met en œuvre une démarche d'accessibilité et
            étudie les besoins des personnes en situation de handicap. Les
            adaptations sont analysées au cas par cas, en lien avec le référent
            handicap, le bénéficiaire, l'entreprise et les partenaires
            compétents lorsque cela est nécessaire.
          </p>
          <h3 className="text-lg font-heading font-bold text-primary-dark mt-8 mb-4" data-id="element-1980" data-mp="2z7kakcl6cv10">
            Conseil de perfectionnement du CFA
          </h3>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1981" data-mp="393dtcdphlkr8">
            En sa qualité de Centre de Formation d'Apprentis, Zillenium
            Alternance met en place un conseil de perfectionnement conformément
            aux dispositions du Code du travail. Cette instance examine les
            questions relatives à l'organisation et au fonctionnement du CFA,
            notamment le projet pédagogique, les conditions d'accueil et
            d'accompagnement des apprentis, l'organisation des formations, les
            relations avec les entreprises et les informations publiées
            annuellement.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1982" data-mp="3o4kmjmndzjcr">
            Les modalités de fonctionnement du conseil de perfectionnement, de
            désignation de ses membres, de convocation, de tenue et de
            traçabilité sont précisées dans les documents internes applicables
            au CFA, notamment le règlement intérieur, la procédure qualité ou
            tout document de gouvernance interne. La programmation de ses
            réunions fait l'objet d'une traçabilité documentaire distincte et
            n'a pas vocation à être fixée dans les présentes Conditions
            générales de vente.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1983" data-mp="2qin9w5vou88q">
            10. Obligations de l'entreprise, du bénéficiaire et de l'apprenti
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1984" data-mp="n2i0nek7y9v3">
            L'entreprise s'engage à conclure et exécuter le contrat
            d'apprentissage conformément à la réglementation applicable, à
            confier à l'apprenti des missions cohérentes avec la certification
            préparée, à désigner un maître d'apprentissage, à favoriser la
            présence de l'apprenti au CFA et à informer Zillenium Alternance de
            toute difficulté pouvant affecter le bon déroulement du parcours.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1985" data-mp="wz4l428muywl">
            Le bénéficiaire s'engage à respecter le règlement intérieur, les
            horaires, les consignes pédagogiques, les règles de sécurité, les
            échéances de production et les modalités d'évaluation. L'assiduité
            en centre de formation constitue une obligation liée au contrat
            d'apprentissage ; toute absence doit être justifiée selon les
            procédures communiquées.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1986" data-mp="3j6931cakseb0">
            L'entreprise et le bénéficiaire s'engagent à coopérer avec Zillenium
            Alternance pour le suivi pédagogique, les bilans, les évaluations,
            les visites ou échanges entreprise-CFA, ainsi que pour toute
            démarche nécessaire à la présentation à la certification.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1987" data-mp="307n0ru3boh5i">
            11. Absences, abandon, rupture anticipée et interruption du parcours
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1988" data-mp="27qkgun55bjb9">
            Toute absence du bénéficiaire doit être signalée et justifiée dans
            les meilleurs délais. Les absences injustifiées, répétées ou
            prolongées peuvent être communiquées à l'entreprise et, lorsque cela
            est nécessaire, au financeur, conformément aux obligations de suivi,
            de justification et de contrôle de service fait.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1989" data-mp="gha765e2z7xo">
            Pour les contrats d'apprentissage, toute rupture, suspension,
            abandon ou interruption anticipée entraîne l'application des
            dispositions du Code du travail, du contrat d'apprentissage, de la
            convention de formation et des règles de prise en charge de l'OPCO
            compétent. Les parties s'engagent à informer sans délai Zillenium
            Alternance afin d'actualiser la situation administrative,
            pédagogique et financière.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1990" data-mp="193brik6g2g1z">
            Les clauses relatives à la rupture, à l'abandon de formation, à la
            résiliation et à l'exclusion sont établies conformément aux
            dispositions applicables aux organismes de formation et aux contrats
            d'apprentissage. Elles précisent les conditions de cessation du
            parcours, les modalités d'information des parties concernées ainsi
            que les conséquences administratives et financières éventuelles.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1991" data-mp="2ex9at4pqe33w">
            Les prestations effectivement réalisées restent dues selon les
            règles de prise en charge applicables, les justificatifs produits et
            les stipulations contractuelles. En cas d'abandon, d'absence
            prolongée non justifiée, de rupture imputable au Client ou de refus
            de prise en charge lié à un dossier incomplet ou irrégulier, les
            sommes non financées par l'OPCO peuvent être facturées à
            l'entreprise, dans la limite des prestations réalisées, engagées ou
            dues selon la convention.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1992" data-mp="347qc9thvhe35">
            Lorsque l'interruption résulte d'un cas de force majeure dûment
            reconnu, seules les prestations effectivement réalisées peuvent être
            facturées au prorata de leur réalisation, sauf disposition légale ou
            contractuelle plus favorable.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1993" data-mp="2lecpibobcdym">
            12. Annulation, report ou modification par Zillenium Alternance
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1994" data-mp="2bj2mplq3c2js">
            Zillenium Alternance se réserve la possibilité de reporter, modifier
            ou annuler une session lorsque les conditions pédagogiques,
            administratives, réglementaires, matérielles ou de sécurité ne
            permettent pas d'assurer la formation dans des conditions
            satisfaisantes, notamment en cas d'effectif insuffisant,
            d'indisponibilité majeure d'un intervenant, de force majeure ou
            d'impossibilité d'organisation.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1995" data-mp="28xbn1l3fen3s">
            Dans ce cas, l'organisme informe les candidats, bénéficiaires et
            entreprises concernés dans les meilleurs délais et recherche,
            lorsque cela est possible, une solution de report, d'aménagement ou
            d'orientation. En cas d'inexécution totale ou partielle d'une
            prestation imputable à Zillenium Alternance, les sommes
            éventuellement indûment perçues au titre des prestations non
            réalisées sont régularisées conformément aux règles applicables.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1996" data-mp="xhwr8kmye1a9">
            Les modifications de calendrier, de salle, d'intervenant ou de
            modalité pédagogique qui n'affectent pas substantiellement les
            objectifs de la formation ne constituent pas une annulation dès lors
            que la qualité pédagogique et les obligations réglementaires sont
            préservées.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-1997" data-mp="2dfv3qos31fcg">
            13. Moyens pédagogiques, évaluation et certification
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1998" data-mp="1zi6ktmhksia1">
            Les moyens pédagogiques mobilisés peuvent comprendre des apports
            structurés, études de cas, ateliers professionnels, jeux de rôle,
            mises en situation, productions écrites ou orales, outils
            numériques, accompagnement individualisé, suivi en entreprise et
            bilans d'acquisition.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-1999" data-mp="3kuzy8pvpjyxg">
            Les modalités d'évaluation sont précisées dans chaque programme :
            évaluations formatives, contrôles, mises en situation, dossiers
            professionnels, productions, oraux, entraînements à la
            certification, épreuves ponctuelles ou contrôles en cours de
            formation lorsque l'habilitation et le règlement de certification le
            permettent.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2000" data-mp="np5wz1gipn09">
            La réussite à la certification ne peut être garantie par Zillenium
            Alternance. L'organisme s'engage à préparer le bénéficiaire aux
            compétences, attendus et modalités certificatives connus, sous
            réserve de son assiduité, de son engagement, de la réalisation des
            travaux demandés et du respect des conditions fixées par le
            certificateur.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2001" data-mp="2d3u86zddgywp">
            14. Accessibilité et situations de handicap
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2002" data-mp="909gdsdt1fg4">
            Zillenium Alternance accueille les personnes en situation de
            handicap dans le cadre d'une étude individualisée. Le candidat, le
            bénéficiaire ou l'entreprise peut solliciter le référent handicap
            afin d'identifier les besoins, les aménagements envisageables, les
            compensations possibles ou les relais partenaires.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2003" data-mp="3lj7oheqoh871">
            Les adaptations sont appréciées en fonction de la formation visée,
            des exigences de certification, des contraintes pédagogiques,
            techniques et organisationnelles, ainsi que des recommandations
            éventuellement transmises par les acteurs compétents. Le contact
            référent handicap est :{' '}
            <a href="mailto:samir@zilleniumalternance.fr" className="text-brand-orange hover:underline font-medium" data-id="element-2004" data-mp="32p2dx89rjems">
              samir@zilleniumalternance.fr
            </a>
            .
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2005" data-mp="198z6hm0kj6lk">
            15. Propriété intellectuelle
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2006" data-mp="20z3wc073klu6">
            Les supports pédagogiques, contenus, méthodes, séquences, exercices,
            cas, documents, ressources numériques et outils remis ou mis à
            disposition par Zillenium Alternance demeurent la propriété de
            l'organisme ou de leurs auteurs respectifs, sauf mention contraire.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2007" data-mp="giz5hy96udnz">
            Le Client, l'apprenti, le bénéficiaire et tout utilisateur
            s'interdisent de reproduire, diffuser, vendre, transférer, adapter,
            publier ou exploiter commercialement tout ou partie des supports ou
            contenus sans autorisation préalable et écrite de Zillenium
            Alternance. L'usage des supports est limité aux besoins personnels
            de formation du bénéficiaire et à l'exécution du parcours concerné.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2008" data-mp="n2ohb30bm5gc">
            16. Confidentialité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2009" data-mp="1esjajaraufaa">
            Les parties s'engagent à conserver confidentielles les informations
            non publiques échangées dans le cadre de la relation contractuelle,
            notamment les données commerciales, pédagogiques, administratives,
            financières, organisationnelles ou personnelles. Cette obligation ne
            fait pas obstacle aux transmissions nécessaires aux financeurs,
            certificateurs, autorités de contrôle, partenaires pédagogiques ou
            organismes légalement habilités.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2010" data-mp="2az4jv68pr4ai">
            L'entreprise s'engage à informer Zillenium Alternance de toute
            information utile à la sécurité, à la santé ou au suivi du
            bénéficiaire, dans le respect des règles de confidentialité et de
            protection des données personnelles.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2011" data-mp="2tob3qwl8u1xw">
            17. Données personnelles et RGPD
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2012" data-mp="32qal5q06781d">
            Zillenium Alternance traite des données personnelles nécessaires à
            l'information, l'admission, la contractualisation, la réalisation,
            le suivi, la facturation, la certification et l'amélioration des
            actions de formation. Ces traitements peuvent concerner les
            candidats, bénéficiaires, apprentis, représentants d'entreprise,
            maîtres d'apprentissage, interlocuteurs financeurs et partenaires.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2013" data-mp="2kooegovo0sms">
            Les données sont utilisées uniquement pour les finalités liées à
            l'activité de l'organisme et peuvent être transmises, lorsque cela
            est nécessaire, aux OPCO, certificateurs, autorités administratives,
            prestataires techniques, partenaires pédagogiques ou organismes
            légalement habilités.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2014" data-mp="2zchta7cxfr4b">
            Une{' '}
            <a href="/confidentialite" className="text-brand-orange hover:underline font-medium" data-id="element-2015" data-mp="3dc0pq2wdle0s">
              politique de confidentialité conforme au RGPD
            </a>{' '}
            est intégrée aux documents de l'organisme. Elle précise l'identité
            du responsable du traitement, les finalités de collecte des données,
            les destinataires, les durées de conservation, les mesures de
            sécurité mises en œuvre ainsi que les droits des personnes
            concernées. Toute demande relative aux données personnelles peut
            être adressée à :{' '}
            <a href={`mailto:${CFA_INFO.rgpdEmail}`} className="text-brand-orange hover:underline font-medium" data-id="element-2016" data-mp="3976wcqqbhtiv">
              {CFA_INFO.rgpdEmail}
            </a>
            .
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2017" data-mp="2zbvfo2vcmc8h">
            18. Réclamations et amélioration continue
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2018" data-mp="2qbgtl1ak8t3x">
            En cas de difficulté relative à l'information, l'admission,
            l'organisation, le déroulement, l'évaluation, l'accessibilité ou la
            facturation d'une formation, le candidat, le bénéficiaire,
            l'apprenti, l'entreprise ou le financeur peut adresser une
            réclamation à Zillenium Alternance par e-mail à{' '}
            <a href={`mailto:${CFA_INFO.email}`} className="text-brand-orange hover:underline font-medium" data-id="element-2019" data-mp="2wqz2ieknyif5">
              {CFA_INFO.email}
            </a>
            , en précisant l'identité du demandeur, la formation concernée, les
            faits constatés et les pièces utiles.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2020" data-mp="2i2kt1ksqrvpm">
            Zillenium Alternance accuse réception de la demande dans un délai
            raisonnable, analyse la situation et apporte une réponse ou une
            proposition de traitement. Les réclamations sont exploitées dans le
            cadre de la démarche qualité et d'amélioration continue de
            l'organisme.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2021" data-mp="jjpqattic5td">
            19. Responsabilité
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2022" data-mp="slyxpathbj2j">
            Zillenium Alternance est tenue à une obligation de moyens dans la
            réalisation de ses prestations. Sa responsabilité ne peut être
            engagée qu'en cas de faute prouvée lui étant directement imputable,
            dans les limites prévues par les textes applicables et les
            stipulations contractuelles.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2023" data-mp="9s36i933syf0">
            L'organisme ne peut être tenu responsable des décisions de l'OPCO,
            de l'entreprise, du certificateur, de l'administration ou de toute
            autorité compétente, notamment en matière de prise en charge,
            d'éligibilité, de recevabilité à l'examen, d'attribution d'aide
            employeur ou de délivrance de certification.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2024" data-mp="3s2cypdqikyw8">
            Le Client demeure responsable de l'exactitude des informations
            transmises, du respect de ses obligations d'employeur, de
            l'exécution du contrat d'apprentissage et de la cohérence des
            missions confiées avec la formation préparée.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2025" data-mp="ewl78t5mbc96">
            20. Force majeure
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2026" data-mp="jpea1bhj0aim">
            Aucune partie ne pourra être tenue responsable d'un retard, d'une
            suspension ou d'une inexécution résultant d'un événement de force
            majeure au sens de la jurisprudence et des textes applicables,
            notamment un événement imprévisible, irrésistible et extérieur
            empêchant l'exécution normale des obligations contractuelles.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2027" data-mp="2e2qibzxar2mw">
            La partie empêchée informe l'autre partie dans les meilleurs délais
            et met en œuvre les mesures raisonnables permettant de limiter les
            conséquences de l'événement. Si l'empêchement se prolonge, les
            parties se rapprochent afin d'examiner les possibilités de report,
            d'aménagement, de suspension ou de résiliation.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2028" data-mp="2s319z56fkl94">
            21. Droit applicable, règlement amiable et juridiction compétente
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2029" data-mp="3kkney1pk0nlm">
            Les présentes CGV sont soumises au droit français. En cas de
            différend relatif à leur interprétation, leur exécution, la
            formation ou la facturation, les parties s'engagent à rechercher
            préalablement une solution amiable.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2030" data-mp="1iw975yqkmd0k">
            À défaut d'accord amiable dans un délai raisonnable, le litige sera
            porté devant les juridictions compétentes conformément aux
            dispositions légales en vigueur.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2031" data-mp="v6yaotg974s8">
            22. Modification des CGV
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2032" data-mp="l8ij6pdbdti7">
            Zillenium Alternance se réserve le droit de modifier les présentes
            CGV à tout moment. Les conditions applicables sont celles en vigueur
            à la date de signature de la convention, d'acceptation du devis ou
            de contractualisation de la formation, sauf disposition impérative
            contraire.
          </p>
          <p className="text-base leading-relaxed text-slate-700 mb-6" data-id="element-2033" data-mp="8u3skamcp4be">
            Si une clause des présentes CGV était déclarée nulle, inopposable ou
            réputée non écrite, les autres clauses conserveraient leur plein
            effet. Le fait pour Zillenium Alternance de ne pas se prévaloir
            ponctuellement d'une clause ne saurait valoir renonciation à s'en
            prévaloir ultérieurement.
          </p>

          <h2 className="text-xl md:text-2xl font-heading font-bold text-primary-dark mt-16 mb-6 pl-4 border-l-4 border-brand-orange" data-id="element-2034" data-mp="momk1r0ranex">
            23. Synthèse des arbitrages intégrés
          </h2>
          <p className="text-base leading-relaxed text-slate-700 mb-8" data-id="element-2035" data-mp="wlrai31mx51j">
            Les présentes CGV intègrent les arbitrages retenus par Zillenium
            Alternance concernant le régime de TVA, les clauses de rupture ou
            d'abandon, la juridiction compétente et la politique de
            confidentialité. Ces éléments sont repris dans les documents
            contractuels, administratifs et financiers de l'organisme selon leur
            objet.
          </p>

          <div className="mt-16 pt-8 border-t border-slate-200" data-id="element-2036" data-mp="1ze3idntqnpvs">
            <p className="text-sm text-slate-500 leading-relaxed mb-4" data-id="element-2037" data-mp="1zcilhrjybuur">
              Références : L'Opcommerce, « Obligations liées à l'exercice de son
              activité et à la vente de prestations » ; OPCO EP, « Les étapes
              essentielles pour le dépôt d'un contrat d'apprentissage » ;
              Ministère du Travail et des Solidarités, « Apprentissage : ce qui
              change au 1er juillet 2025 » (publié le 30 juin 2025).
            </p>
            <p className="text-sm text-slate-600 font-semibold" data-id="element-2038" data-mp="1ki5ns9zgqtlo">
              Zillenium Alternance — ZILLENIUM SAS — UAI {CFA_INFO.uai} —
              Conditions générales de vente — Version 1.0
            </p>
          </div>
        </div>
      </div>
    </div>;
}